import { Button, Radio } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    text-transform: none;
    justify-content: space-between;
    font-family: Lato;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    .MuiButton-endIcon div {
      right: 12px;
    }
  }
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  gap: 15px;
`;

export const StyledRadio = styled((props) => <Radio {...props} />)`
  &&& {
    justify-content: flex-start;
    height: 33px;

    .MuiFormControlLabel-label {
      font-size: 13px;
      line-height: 18.2px;
      font-weight: 400;
    }

    div[class*='-icon-'],
    div[class*='-checkedIcon-'] {
      width: 16px;
      height: 16px;

      div {
        height: 10px;
        width: 10px;
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 18.2px;
`;
